import { Field, useFormik, FormikContext, ErrorMessage } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { selectOneTaskLineFormSchema, convertStringLineToObjectLine, SelectOneTaskLine } from 'shared/types/task';

export interface LineFormProps {
  handleAdd: (val: SelectOneTaskLine) => void;
}

export default function LineForm({ handleAdd }: LineFormProps) {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      line: '',
    },
    onSubmit: (values, { resetForm }) => {
      handleAdd(convertStringLineToObjectLine(values.line));
      resetForm();
    },
    validationSchema: selectOneTaskLineFormSchema,
  });
  const { isSubmitting, isValid, submitForm } = formik;

  return (
    <FormikContext.Provider value={formik}>
      <div className="text-uppercase my-[12px] text-[14px] font-bold lg:text-[18px]">{t('new line')}</div>
      <div className="relative">
        <Field
          type="text"
          name="line"
          className="mb-[15px] h-[44px] w-full !rounded-[8px] !border-[1px] !border-[#52C7FA] px-2"
        />

        {!isValid && <p className="mh-fit text-sm font-medium text-red-600">{t('selectOneTaskErrorMessage')}</p>}
      </div>

      <button
        className="btn btn-primary moreStatic !px-[50px] lg:w-[240px]"
        onClick={submitForm}
        disabled={isSubmitting || !isValid}
      >
        + {t('add line')}
      </button>
    </FormikContext.Provider>
  );
}
